/**
 * Created by BFR on 18/02/2020.
 */
define('pimOverviewTabController',[
  'module',
  'underscore',
  'app',
  'pimProductEditsTabView'
], function (
  module,
  _,
  App,
  View
) {

  'use strict';
  var PimProductEditsController = {

    showDetails: function (region, model) {
      //var product = App.request('pim-products-rel:model', {id: productModel.get('id')});
      this.model = model;
      this.region = region;    
      this.view = new View({model: model});

      region.show(this.view);

      /*product.fetch().done(_.bind(function () {
        this.view = new View({model: product});
        this.view.listenTo(this.view, 'pim-product-overview:reload', _.bind(this.onReload, this));
        region.show(this.view);
      }, this));*/
    },

    onReload: function () {
      this.showDetails(this.region, this.model);
    }   
  };

  module.exports = PimProductEditsController;
});
